import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'action-triggers',
    templateUrl:'actionTriggers.html'
})
export class ActionTriggerComponent implements OnInit{

  public action;
  public option: string;
  public hand:string;
  public actionOption: string;
  public trigger;
  public actionIndex;
  public triggers;
  public showActionOptions
  public showTable;
  public distanceForm: FormGroup;
  public buttonForm: FormGroup;

  public onSuccessThumbs=[
    {name:'Iniciar audio',kind:'audioShowActionSecond'},
    {name:'Iniciar imagem',kind:'imageShowActionSecond'},
    {name:'Iniciar video',kind:'videoShowActionSecond'},
    {name:'Adicionar Itens',kind:'addItensSecondAction'},
    {name:'Remover Itens',kind:'removeItensSecondAction'},
    {name:'Missão',kind:'writSecondAction'},
    {name:'Porta',kind:'doorSecondAction'}


  ]
  public onFailThumbs=[
    {name:'Iniciar audio',kind:'audioShowActionSecond'},
    {name:'Iniciar imagem',kind:'imageShowActionSecond'},
    {name:'Iniciar video',kind:'videoShowActionSecond'},
    {name:'Adicionar Itens',kind:'addItensSecondAction'},
    {name:'Remover Itens',kind:'removeItensSecondAction'},
    {name:'Missão',kind:'writSecondAction'},
    {name:'Porta',kind:'doorSecondAction'}
  ]
  public onCloseThumbs=[
    {name:'Iniciar audio',kind:'audioShowActionSecond'},
    {name:'Iniciar imagem',kind:'imageShowActionSecond'},
    {name:'Iniciar video',kind:'videoShowActionSecond'},
    {name:'Adicionar Itens',kind:'addItensSecondAction'},
    {name:'Remover Itens',kind:'removeItensSecondAction'},
    {name:'Missão',kind:'writSecondAction'},
    {name:'Porta',kind:'doorSecondAction'}

  ]
  public constructor(public translate: TranslationService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
    this.option='';
    this.actionOption='';
    this.trigger=[]
    this.showActionOptions=false;
    this.distanceForm = this.fb.group({
      dXParam: 0,
      dYParam: 0,
    });
    this.buttonForm = this.fb.group({
      text: '',
      color: '',
    });
  }
  public selectOption(option){
    this.option=option;
    if (!this.triggers[option]){this.triggers[option]=[]}
    this.trigger=this.triggers[option];
    this._appData.secondTriggers=this.triggers;
    this._appData.activeSecondTrigger=option;
    this.showTable=true;
    this.showActionOptions=false
    this.action=null
    if (option=='onSuccess'){
      if (!this._appData.action.param.onSuccess){
        this._appData.action.param.onSuccess={text:"Correto",color:'0x1f304a'}
      }

      this.buttonForm = this.fb.group({
        text: this._appData.action.param.onSuccess.text ? this._appData.action.param.onSuccess.text : 'Correto',
        color: this._appData.action.param.onSuccess.color ? this._appData.action.param.onSuccess.color : '0x1f304a',
      });
    }
    else{
      if (!this._appData.action.param.onFail){
        this._appData.action.param.onFail={text:"Errado",color:'0x4a2a1f'}
      }
      this.buttonForm = this.fb.group({
        text: this._appData.action.param.onFail.text ? this._appData.action.param.onFail.text : 'Errado',
        color: this._appData.action.param.onFail.color ? this._appData.action.param.onFail.color : '0x4a2a1f',
      });
    }

  }
  public selectActionOption(action){
    this.trigger.push({
      kind:action.kind,
      param:{}
    })
    this.triggers[this.option]=this.trigger;
    this._appData.secondTriggers=this.triggers;
    this.showActionOptions=false
    this.showTable=true;
    document.getElementById('item-trigger-reload').click();

  }
  public addAction(){
    this.showTable=false;
    this.showActionOptions=true
  }
  public editAction(j){
    let action=this.trigger[j]   
    this.showTable=false;
    this.action=action.kind;
    this._appData.secondAction=action;
    this.actionIndex=j;
    setTimeout(()=>{
      document.getElementById('action-'+action.kind+'-reload').click();
    },1000)
    this.distanceForm = this.fb.group({
      dXParam: action.param.dx ? action.param.dx:0,
      dYParam: action.param.dy ?action.param.dy:0
    })

  }
  public actionDone(){
    this.action=null;
    this.trigger[this.actionIndex]=this._appData.secondAction;
    this._appData.secondAction=null;
    this.triggers[this.option]=this.trigger;
    this._appData.secondTriggers=this.triggers;
    this._appData.action.triggers=this.triggers;
    this.showTable=true;
  }
  public removeAction(j){
    this.trigger.splice(j,1)
  }
  public reload(){
    this.triggers = this._appData.secondTriggers;
    if (!this.triggers){
      this.triggers={}
    }
    this.showActionOptions=false
    this.action=null
    this.showTable=false;

    document.getElementById('item-trigger-reload').click();


  }
  public ngOnInit(): any {
      this.triggers = this._appData.secondTriggers;
      if (!this.triggers){
        this.triggers={}
      }
  }

  public updateText(){
    let text = this.buttonForm.controls['text'].value;
    let color = this.buttonForm.controls['color'].value;
    this._appData.action.param[this.option].text=text;
    this._appData.action.param[this.option].color=color;
  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/triggers/actionTriggers.ts